export default __webpack_public_path__ + "static/media/edit.46d27001.svg";